const STORAGE_PREFIX = 'k12-onboarding-checklist-subtasks-v1';

function buildKey(accountId: string | number, pageId: string): string {
  return `${STORAGE_PREFIX}:${String(accountId)}:${pageId}`;
}


function normalizeSubtaskArray(parsed: unknown, count: number): boolean[] {
  if (!Array.isArray(parsed)) return Array(count).fill(false);
  const out: boolean[] = Array(count).fill(false);
  for (let i = 0; i < count; i++) {
    out[i] = Boolean(parsed[i]);
  }
  return out;
}

export interface TasklistPageProgress {
  subtasks: boolean[];
  taskMarkedComplete: boolean;
}


export function loadTasklistPageProgress(
  accountId: string | number | undefined,
  pageId: string | undefined,
  subtaskCount: number
): TasklistPageProgress {
  if (!accountId || !pageId || typeof window === 'undefined') {
    return {
      subtasks: Array(Math.max(0, subtaskCount)).fill(false),
      taskMarkedComplete: false,
    };
  }

  if (subtaskCount < 0) {
    return { subtasks: [], taskMarkedComplete: false };
  }

  if (subtaskCount === 0) {
    try {
      const raw = window.localStorage.getItem(buildKey(accountId, pageId));
      if (!raw) {
        return { subtasks: [], taskMarkedComplete: false };
      }
      const parsed = JSON.parse(raw) as unknown;
      if (parsed && typeof parsed === 'object' && 'taskMarkedComplete' in parsed) {
        const o = parsed as { taskMarkedComplete?: unknown };
        return { subtasks: [], taskMarkedComplete: Boolean(o.taskMarkedComplete) };
      }
      if (Array.isArray(parsed)) {
        return { subtasks: [], taskMarkedComplete: false };
      }
    } catch {
      /* ignore */
    }
    return { subtasks: [], taskMarkedComplete: false };
  }

  try {
    const raw = window.localStorage.getItem(buildKey(accountId, pageId));
    if (!raw) {
      return { subtasks: Array(subtaskCount).fill(false), taskMarkedComplete: false };
    }
    const parsed = JSON.parse(raw) as unknown;
    if (Array.isArray(parsed)) {
      return {
        subtasks: normalizeSubtaskArray(parsed, subtaskCount),
        taskMarkedComplete: false,
      };
    }
    if (parsed && typeof parsed === 'object' && 'subtasks' in parsed) {
      const o = parsed as { subtasks?: unknown; taskMarkedComplete?: unknown };
      return {
        subtasks: normalizeSubtaskArray(o.subtasks, subtaskCount),
        taskMarkedComplete: Boolean(o.taskMarkedComplete),
      };
    }
    return { subtasks: Array(subtaskCount).fill(false), taskMarkedComplete: false };
  } catch {
    return { subtasks: Array(subtaskCount).fill(false), taskMarkedComplete: false };
  }
}

export function saveTasklistPageProgress(
  accountId: string | number | undefined,
  pageId: string | undefined,
  progress: TasklistPageProgress
): void {
  if (!accountId || !pageId || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(
      buildKey(accountId, pageId),
      JSON.stringify({
        subtasks: progress.subtasks,
        taskMarkedComplete: progress.taskMarkedComplete,
      })
    );
  } catch {
  }
}

/**
 * @deprecated Prefer {@link loadTasklistPageProgress}
 */
export function loadTasklistSubtaskCompletion(
  accountId: string | number | undefined,
  pageId: string | undefined,
  count: number
): boolean[] {
  return loadTasklistPageProgress(accountId, pageId, count).subtasks;
}

/**
 * @deprecated Prefer {@link saveTasklistPageProgress}; p
 */
export function saveTasklistSubtaskCompletion(
  accountId: string | number | undefined,
  pageId: string | undefined,
  completed: boolean[]
): void {
  const prev = loadTasklistPageProgress(accountId, pageId, completed.length);
  saveTasklistPageProgress(accountId, pageId, {
    subtasks: completed,
    taskMarkedComplete: prev.taskMarkedComplete,
  });
}
